import {actionNames} from 'constants/index';
const actions ={};

actions.DATOS_GENERALES_CIUDADANO =(state)=>{
    return { type:actionNames.DATOS_GENERALES_CIUDADANO, state};
}
actions.DATOS_SOLICITUD_EXTRANJERO =(state)=>{
    return { type:actionNames.DATOS_SOLICITUD_EXTRANJERO, state};
}
actions.SOLICITUD_EMPADRONAMIENTO_SET_LISTADOS_ARRAY =(state)=>{
    return { type:actionNames.SOLICITUD_EMPADRONAMIENTO_SET_LISTADOS_ARRAY, state};
}
actions.SOLICITUD_EMPADRONAMIENTO_SET_ES_PADRON_RENAP =(state)=>{
    return { type:actionNames.SOLICITUD_EMPADRONAMIENTO_SET_ES_PADRON_RENAP, state};
}
actions.SOLICITUD_EMPADRONAMIENTO_SET_ID_SOLICITUD_GENERADO =(state)=>{
    return { type:actionNames.SOLICITUD_EMPADRONAMIENTO_SET_ID_SOLICITUD_GENERADO, state};
}
actions.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_GENERADO =(state)=>{
    return { type:actionNames.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_GENERADO, state};
}
actions.SOLICITUD_EMPADRONAMIENTO_SET_IS_INSCRIPCION_ACTUALIZACION =(state)=>{
    return { type:actionNames.SOLICITUD_EMPADRONAMIENTO_SET_IS_INSCRIPCION_ACTUALIZACION, state};
}
actions.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_MUNICIPIOS =(state)=>{
    return { type:actionNames.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_MUNICIPIOS, state};
}
actions.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS =(state)=>{
    return { type:actionNames.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS, state};
}
actions.SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD_EN_EL_EXTRANJERO =(state)=>{
    return { type:actionNames.SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD_EN_EL_EXTRANJERO, state};
}
actions.ID_SOLICITUD_DELEGACION_PROCESADO =(state)=>{
    return { type:actionNames.ID_SOLICITUD_DELEGACION_PROCESADO, state};
}
actions.CATALOGO_DISCAPACIDAD =(state)=>{
    return { type:actionNames.CATALOGO_DISCAPACIDAD, state};
}
actions.CATALOGO_CLASIFICACION_DISCAPACIDAD =(state)=>{
    return { type:actionNames.CATALOGO_CLASIFICACION_DISCAPACIDAD, state};
}
actions.DATOS_SOLICITUD_DELEGACION =(state)=>{
    return { type:actionNames.DATOS_SOLICITUD_DELEGACION, state};
}
export default actions;